import { Fragment } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import ReactPaginate from 'react-paginate';
import { withRouter } from 'react-router';

import { toggleOnEditMode, toggleOffEditMode } from 'app/action-creators';
import { PER_PAGE } from 'app/constants';
import Wait from 'components/wait';

const getPage = (state) => (state || {}).page || 1;

const Header = ({
  title,
  isIdsEmpty,
  enableSelectMode,
  onDelete,
  titleBtns,
  handleDelete,
  disabled,
  disableSelectMode,
  hideActionButtons,
}) => {
  return (
    <div className="page-title">
      <h3>
        <Translate value={title} />
      </h3>

      {hideActionButtons ? null : isIdsEmpty ? (
        <Fragment>
          {onDelete && (
            <a
              href="#"
              className="btn btn-secondary"
              onClick={enableSelectMode}
            >
              <Translate value="common.edit" />
            </a>
          )}

          {titleBtns}
        </Fragment>
      ) : (
        <Fragment>
          <a href="#" className="btn btn-secondary" onClick={disableSelectMode}>
            <Translate value="common.cancel" />
          </a>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDelete}
            disabled={disabled}
          >
            <Translate value="common.delete" />
          </button>
        </Fragment>
      )}
    </div>
  );
};

class Table extends React.Component {
  constructor(props) {
    super();
    this.enableSelectMode = this.enableSelectMode.bind(this);
    this.disableSelectMode = this.disableSelectMode.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.state = {
      page: getPage(props.location.state),
      ids: null,
      sorting: props.headers[0][1],
      sortingBack: props.sortingBack || false,
      isSelectAllCheckbox: false,
    };
  }

  componentWillReceiveProps(props) {
    if (props.list.length !== this.props.list.length) {
      let { page } = this.state;
      if (page === 1) return;
      if (props.list.length < page * PER_PAGE) {
        this.onPageChange(page - 1);
      }
    }
  }

  componentWillUnmount() {
    this.props.toggleOffEditMode();
  }

  enableSelectMode(e) {
    e.preventDefault();
    this.props.toggleOnEditMode();
    this.setState({ ids: [] });
  }

  onDelete(e) {
    e.preventDefault();

    const { toggleOffEditMode } = this.props;

    const actions = {};

    toggleOffEditMode();

    this.props
      .onDelete(this.state.ids, actions)
      .then(() => this.setState({ ids: null, isSelectAllCheckbox: false }));
  }

  onSelect(id) {
    let { ids } = this.state;
    if (ids.includes(id)) {
      this.setState({ ids: ids.filter((i) => i !== id) });
    } else {
      this.setState({ ids: ids.concat([id]) });
    }
  }

  disableSelectMode(e) {
    e.preventDefault();
    this.props.toggleOffEditMode();
    this.setState({ ids: null });
  }

  onPageChange(page) {
    this.props.history.replace(this.props.location.pathname, { page });
    this.setState({ page });
  }

  onSortChange(sorting) {
    if (this.state.sorting === sorting) {
      this.setState({ sortingBack: !this.state.sortingBack });
    } else {
      this.setState({ sorting, sortingBack: false });
    }
  }

  renderItem(item) {
    return this.props.renderRow(
      item,
      this.state.ids,
      this.onSelect.bind(this, item.id)
    );
  }

  onSelectAllCheckbox = () => {
    const { ids, page } = this.state;
    const { list } = this.props;
    if (ids.length > 0) {
      this.setState({
        isSelectAllCheckbox: false,
        ids: [],
      });
    } else {
      this.setState({
        isSelectAllCheckbox: true,
        ids: list
          .slice((page - 1) * PER_PAGE, page * PER_PAGE)
          .reduce((acc, item) => {
            acc.push(item.id);
            return acc;
          }, []),
      });
    }
  };

  reduceHeaders = (headers) => {
    return headers.reduce(
      (acc, [width, key, sorting]) => {
        if (!['app_update', 'comment', 'description', 'logs'].includes(key)) {
          let icon;
          if (this.state.sorting === key) {
            if (this.state.sortingBack) {
              acc.sorting = (...args) => sorting(...args) * -1;
              icon = 'sort-down';
            } else {
              acc.sorting = sorting;
              icon = 'sort-up';
            }
          } else {
            icon = 'sort';
          }

          acc.headers.push(
            <th
              key={key}
              width={`${width}%`}
              onClick={key ? this.onSortChange.bind(this, key) : null}
            >
              <a href="#">
                <Translate value={`attrs.${key}`} />
                <span className={`fa fa-${icon} ml-1`} />
              </a>
            </th>
          );
        } else {
          acc.headers.push(
            <th key={key} width={`${width}%`}>
              <a href="#">
                <Translate value={`attrs.${key}`} />
              </a>
            </th>
          );
        }
        acc.actionWidth -= width;
        return acc;
      },
      { headers: [], actionWidth: 100, sorting: () => {} }
    );
  };

  renderPagination = () => {
    const { page } = this.state;
    const { list, children } = this.props;

    if (children) return children;

    if (list.length <= PER_PAGE) return null;

    return (
      <ReactPaginate
        pageCount={Math.ceil(list.length / PER_PAGE)}
        pageRangeDisplayed={5}
        marginPagesDisplayed={2}
        onPageChange={(data) => this.onPageChange(data.selected + 1)}
        forcePage={page - 1}
        containerClassName="pagination"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
        disabledClassName="disabled"
        previousLabel={<span aria-hidden="true">&laquo;</span>}
        nextLabel={<span aria-hidden="true">&raquo;</span>}
        breakLabel="..."
      />
    );
  };

  render() {
    const { page, isSelectAllCheckbox } = this.state;
    const {
      editMode,
      onDelete,
      hideActionButtons,
      isLoading,
      renderHeaderRow,
    } = this.props;
    const isIdsEmpty = this.state.ids === null;
    const { headers, actionWidth, sorting } = this.reduceHeaders(
      this.props.headers
    );
    const list = renderHeaderRow
      ? this.props.list
      : [...this.props.list]
          .sort(sorting)
          .slice((page - 1) * PER_PAGE, page * PER_PAGE);
    const disabled =
      Array.isArray(this.state.ids) && this.state.ids.length === 0;

    return (
      <div>
        {this.props.pageHeader || (
          <Header
            title={this.props.title}
            isIdsEmpty={isIdsEmpty}
            enableSelectMode={this.enableSelectMode}
            onDelete={onDelete}
            handleDelete={this.onDelete}
            titleBtns={this.props.titleBtns}
            disabled={disabled}
            disableSelectMode={this.disableSelectMode}
            hideActionButtons={!!hideActionButtons}
          />
        )}

        {this.renderPagination()}

        <table className="table table-striped">
          <thead>
            {renderHeaderRow ? (
              renderHeaderRow()
            ) : (
              <tr>
                {headers}
                <th style={{ textAlign: 'right' }} width={`${actionWidth}%`}>
                  {editMode && (
                    <span
                      className={`fa fa-${isSelectAllCheckbox ? 'check-square-o' : 'square-o'}`}
                      style={{ fontSize: '1.25rem' }}
                      onClick={this.onSelectAllCheckbox}
                    />
                  )}
                </th>
              </tr>
            )}
          </thead>
          {!isLoading && <tbody>{list.map(this.renderItem)}</tbody>}
        </table>

        {isLoading && <Wait />}
      </div>
    );
  }
}

const mapStateToProps = ({ data, qrDiagnostics }) => {
  return {
    editMode: data.editMode,
    isLoading: qrDiagnostics.isLoading,
  };
};

export default compose(
  connect(mapStateToProps, {
    toggleOnEditMode,
    toggleOffEditMode,
  }),
  withRouter
)(Table);
